import React, { Component } from "react";

class MassiveLoadContainer extends Component {
  state = {
    endOfPrompt: true,
    propmt: '-'
  }

  componentDidUpdate = () => {
    if (this.state.endOfPrompt) {
      this.refs.scrolable.scrollTop = this.refs.scrolable.scrollHeight
    }

  }

  handlerScroll = (e) => {
    if (this.refs.scrolable.scrollTop + this.refs.scrolable.clientHeight === this.refs.scrolable.scrollHeight) {
      if (!this.state.endOfPrompt) this.setState({ endOfPrompt: !this.state.endOfPrompt })
    } else {
      if (this.state.endOfPrompt) this.setState({ endOfPrompt: !this.state.endOfPrompt })
    }
  }
  componentDidMount = () => {
    this.int = setInterval(() => {
      let propmt = '-'
      if (this.state.propmt === '-') propmt = '\\'
      if (this.state.propmt === '\\') propmt = '|'
      if (this.state.propmt === '|') propmt = '/'
      if (this.state.propmt === '/') propmt = '-'
      this.setState({ propmt })
    }, 250)
  }

  render() {
    return (
      <>
        <div className='line line-100'>
          <div className='command-prompt' ref='scrolable' onScroll={this.handlerScroll}>
            {
              this.props.propmt.map(out => <p>{out}</p>)
            }
            {
              this.props.load &&
              <p>{this.state.propmt}</p>
            }
        </div>
      </div>
      </>
    );
  }
}

export default MassiveLoadContainer;
